<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1" id="pt1"> </p>
<p class="PT">EARTH</p>
<p class="PEP">Sufficient unto the day is the evil thereof.</p>
<div class="PEPC-SP">
<p class="PEPC"><span class="pepc-CAPS">M</span><span class="ePub-SC">ATTHEW</span> 6:34</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?714d87a0